import React from 'react';
import { useT } from '../../i18n';

// Indicateur de chargement : anneau qui tourne aux couleurs du thème.
// `page` : centré dans toute la fenêtre (écrans entiers en attente de données).
interface SpinnerProps {
  page?: boolean;
  size?: number;
  label?: string; // texte lu par les lecteurs d'écran
}

const Spinner: React.FC<SpinnerProps> = ({ page = false, size, label }) => {
  const t = useT();
  const px = size ?? (page ? 40 : 28);
  return (
    <div className={page ? 'ui-spinner-page' : 'ui-spinner-wrap'} role="status" aria-live="polite">
      <span className="ui-spinner" style={{ width: px, height: px }} aria-hidden="true" />
      <span className="sr-only">{label || t('Chargement…')}</span>
    </div>
  );
};

export default Spinner;
